import InputField from '../../inputs/inputField'
import { type nft } from '#types/loreTypes.tsx'
import MediaUpload from '#app/components/inputs/mediaUpload.js'

export default function MediaForm({
	nft,
	formData,
	selectedForm,
	setFormData,
	file,
	setFile,
	requiredFields,
	errorFields,
}: {
	nft?: nft | nft[]
	formData: any
	selectedForm: { name: string; slug: string; icon: null; version: string }
	setFormData: (data: any) => void
	file?: File
	setFile: (file: File | undefined) => void
	requiredFields: any[]
	errorFields: any[]
}) {
	return (
		<div className="flex w-full flex-col gap-y-2">
			<MediaUpload
				isValid={true}
				isError={errorFields.findIndex(field => field.name === 'media') >= 0}
				// icon,
				// containerWidth = 'w-full',
				value={undefined}
				label={'Drop your media file or click to upload'}
				helper={
					'Supports: PNG, JPEG, GIF, PDF, MP4, MP3 . Max file size: 4.5 MB'
				}
				// onChange = () => {},
				// onDelete = () => {},
				currentFile={file}
				setFile={setFile}
				isUploading={false}
			/>
			<TextFields formData={formData} setFormData={setFormData} />
		</div>
	)
}

export const TextFields = ({
	formData,
	setFormData,
}: {
	formData: any
	setFormData: (data: any) => void
}) => {
	const handleDataChange = (name: string, value: string) => {
		let newData = { ...formData }
		newData[name] = value
		setFormData(newData)
	}

	return (
		<div className="flex w-full flex-col gap-y-2">
			<InputField
				name="title (optional)"
				type="text"
				placeholder="Enter Title"
				containerWidth="w-full"
				value={formData.title}
				onChange={e => {
					handleDataChange('title', e.target.value)
				}}
			/>

			<InputField
				name="description (optional)"
				type="text"
				placeholder="Add context to this Media Attestation"
				containerWidth="w-full"
				value={formData.description}
				onChange={e => {
					handleDataChange('description', e.target.value)
				}}
			/>
		</div>
	)
}
